import app from "../data/base";

const addInArchive = async (sessionDTO) => {
  try {
    console.log('addTranscription');
    console.log(sessionDTO);

    const response = await app.methods.callserver('api/audioma/v1/add ', 'POST', null, sessionDTO, true);
    const responseJson = await response.json();

    console.log(responseJson);
    if(responseJson.status === 200) {
      console.log('addTranscription End');
      return responseJson;
    }
    throw new Error(responseJson.error);

  } catch (err) {
    // console.log('[api/audioma/v1/add] Error on getList');
    // console.error(err);
    throw err;
  }
}

const editInArchive = async (sessionDTO) => {
  try {
    console.log('editTranscription');
    console.log(JSON.stringify(sessionDTO));
    const response = await app.methods.callserver('api/audioma/v1/edit ', 'POST', null, JSON.stringify(sessionDTO), true);
    const speakers = await response.json();
    console.log(speakers);
    console.log('editTranscription End');
    return speakers;

  } catch (err) {
    console.log('[api/audioma/v1/add] Error on getList');
    console.error(err);
    throw err;
  }
}

const convertTranscription = async ({idSessione}) => {
  try {
    const response = await app.methods.callserver(`api/recorder/v1/convert?idSession=${idSessione}`, 'POST', null, null, true);
    return response;
  } catch (e) {
    console.log(`[/api/recorder/v1/convert?idSession=${idSessione}]: Errore conversione `, e);
    throw e;
  }
}

const convertMultimediaToMp3 = async ({idSessione}) => {
  try {
    const response = await app.methods.callserver(`api/recorder/v1/convertSessionMedia?idSession=${idSessione}`, 'POST', null, null, true);
    return response;
  } catch (e) {
    console.log(`[/api/recorder/v1/convertSessionMedia?idSession=${idSessione}]: Errore conversione `, e);
    throw e;
  }
}

const addSpeakersToTranslations = async ({idSessione}) => {
  try {
    const response = await app.methods.callserver(`api/recorder/v1/update?idSession=${idSessione}`, 'POST', null, null, true);
    return response;
  } catch (e) {
    console.log(`[/api/recorder/v1/update?idSession=${idSessione}]: Errore conversione `, e);

  }
}

const cutVideo = async ({start, end, idSession}) => {

  const body = {
    start: start * 1000,
    end: end * 1000,
    idSession
  }
  try {
    const response = await app.methods.callserver(`api/recorder/v1/cut`, 'POST', null, JSON.stringify(body), true);
    return await response.json();
  } catch (e) {
    console.log(`[api/recorder/v1/cut]: Errore cut `, e);
  }
}

const segmentSpeakers = async ({idSessione}) => {
  try {
    const response = await app.methods.callserver(`api/recorder/v1/segmentSpeakers`, 'POST', null, JSON.stringify({idSession: 	idSessione}), true);
    return await response.json();
  } catch (e) {
    console.log(`[api/recorder/v1/segmentSpeakers]: Errore segmentSpeakers `, e);
  }
}

export const recorder = {
  methods: {
    addInArchive,
    editInArchive,
    convertTranscription,
    convertMultimediaToMp3,
    addSpeakersToTranslations,
    cutVideo,
    segmentSpeakers 
  }
}
